import React from 'react'
import 'chartjs-plugin-datalabels'
import {Chart,CategoryScale,LinearScale,registerables} from 'chart.js';
import { Bar } from 'react-chartjs-2'
import ChartDataLabels from 'chartjs-plugin-datalabels';
export const BarChartMultiple = (props) => {

  Chart.register(CategoryScale);
  Chart.register(LinearScale);
  Chart.register(...registerables);

  Chart.register(ChartDataLabels);
  const generateColor = (size) => {
    const colors = []
    for (let i = 0; i < size; ++i) {
      let color = Math.floor(Math.random() * 16777215).toString(16)
      colors.push('#' + color)
    }
    return colors
  }

  const options = {
    plugins: {
      datalabels: {
      
        display: function(context) {
          var dataset = context.dataset;
          var count = dataset.data.length;
          var value = dataset.data[context.dataIndex];
          
          return true
        },
        font: {
          weight: 'bold'
        },
        padding: 13,
      }
    },
    maintainAspectRatio: false,
    indexAxis: props.indexAxis,
    scales: {
      yAxis: 
        {
          ticks: {
            beginAtZero: true,
          },
        },
    },
    legend: {
      display: false
    }
  }
  
  const colors = generateColor(props.labels.length)


  const datasets = props.datasets.map((dataset, index) => {
    
    return {
      label: dataset.label,
      data: dataset.data,
      backgroundColor: colors[index],
      datalabels: {
        anchor: "end",
        backgroundColor: '#fff',
        borderWidth: 0,
        padding:1,
        color:'#000'
      }
    }
  })
  
  return (
    <div >
      <Bar
      height={props.height}
        data={{
          labels: props.labels,
          datasets: datasets,
        }}
        options={options}
      />
    </div>
  )
}
